import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import s from './SortSelect.scss';

const SelectDropdown = ({
  options,
  onSelect,
  selectedOption,
  placeHolder = '',
  sort = false,
  isWapView = false,
  typeTwoStyle,
  selected,
  active,
  label,
  Url,
  searchOperation = false,
  handleToggleIcon,
  isMobile,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputData, setInputData] = useState(
    selectedOption && selectedOption.name !== '' ? selectedOption.name : '',
  );
  const [filterOption, setFilterOption] = useState([]);
  const [isCleared, setIsCleared] = useState(false);
  const inputRef = useRef(null);
  const optionListRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleToggle = e => {
    if (sort) {
      onSelect(e);
      return;
    }
    setIsOpen(!isOpen);
    setFilterOption([...options]);
  };
  useEffect(
    () => {
      if (searchOperation && selectedOption && selectedOption?.name !== '') {
        setInputData(selectedOption.name);
      }
    },
    [selectedOption],
  );
  const handleFocus = event => {
    event.preventDefault();
    if (inputRef?.current && !isMobile) {
      inputRef.current.select();
    }
    if (isMobile) {
      setInputData('');
    }
  };
  const notOptionsValue =
    label &&
    label !== '' &&
    label !== undefined &&
    typeof label === 'string' &&
    label.split('Select ').length > 0
      ? `${label.split('Select ')[1]} not found`
      : 'Result not found';
  useEffect(
    () => {
      if (searchOperation && options && options.length > 0) {
        const filteredOptions = options.filter(val => {
          if (inputData === '') {
            return val;
          } else if (
            val.name
              .toString()
              .toLowerCase()
              .includes(inputData?.toLowerCase())
          ) {
            return val;
          }
          return false;
        });

        if (filteredOptions.length === 0) {
          setFilterOption([{ name: notOptionsValue }]);
        } else {
          setFilterOption(filteredOptions);
        }
      } else {
        setFilterOption([...options]);
      }
    },
    [inputData],
  );

  const handleSelect = option => {
    if (!sort) {
      onSelect(option);
    }
    setIsOpen(false);
  };

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const handleChangeInput = e => {
    if (!isCleared) {
      setInputData('');
      setInputData(e.target.value);
      setIsCleared(true);
    } else {
      setInputData(e.target.value);
    }
  };
  const handleBlur = event => {
    const nextElement = event.relatedTarget;
    if (optionListRef.current && optionListRef.current.contains(nextElement)) {
      // Do nothing if focus is within the dropdown
    } else {
      setInputData(selectedOption.name);
      setIsCleared(false);
    }
  };
  let className = `${s.sortWrap} sortWrap ${s.filterWrap}`;

  if (typeTwoStyle) {
    className += ` ${s.typeTwo}`;
  }

  if (isOpen) {
    className += ` ${s.show} show`;
  }

  if (!sort && options && Array.isArray(options) && options.length === 1) {
    if (!Url) {
      className += ` ${s.gray}`;
    }
  }

  if (selected) {
    className += ` ${s.selected}`;
  }

  if (active) {
    className += ` ${s.active}`;
  }

  return (
    <div
      className={className}
      onClick={
        (options && Array.isArray(options) && options.length > 1) ||
        handleToggleIcon
          ? handleToggle
          : null
      }
      ref={dropdownRef}
    >
      {label && label !== '' && label !== undefined ? (
        <span className={s.label}>{label}</span>
      ) : (
        ''
      )}
      <div className={s.sortContent}>
        {sort && (
          <>
            <i className={s.sortIocn} onClick={onSelect} />
            {!isWapView && <>Sort By : </>}
          </>
        )}
        {searchOperation && (
          <input
            className={s.search_input}
            id="searchOperation"
            type="text"
            ref={inputRef}
            value={inputData}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChangeInput}
          />
        )}
        {!searchOperation && (
          <span>
            <span>{placeHolder ? `${placeHolder}: ` : ''}</span>{' '}
            {selectedOption?.name || ''}
          </span>
        )}
        {!sort &&
          handleToggleIcon &&
          (options && Array.isArray(options) && options.length > 0) && (
            <i className={s.downArrowIcon} />
          )}
        {!sort &&
          !handleToggleIcon &&
          (options && Array.isArray(options) && options.length > 1) && (
            <i className={s.downArrowIcon} />
          )}
      </div>
      {!sort && (
        <ul className={`${s.sortList} sortList`} ref={optionListRef}>
          {filterOption &&
            Array.isArray(filterOption) &&
            filterOption.length &&
            filterOption.map((item, index) => (
              <li
                key={index}
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex={0}
                onClick={() => handleSelect(item)}
                className={`${
                  item.name &&
                  typeof item.name === 'string' &&
                  item?.name.toLowerCase() === selectedOption?.name
                    ? s.active
                    : ''
                }`}
              >
                {item.name}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

SelectDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedOption: PropTypes.string.isRequired,
};

export default SelectDropdown;
